import { render, staticRenderFns } from "./conoce.vue?vue&type=template&id=40a55009&scoped=true&"
import script from "./conoce.vue?vue&type=script&lang=js&"
export * from "./conoce.vue?vue&type=script&lang=js&"
import style0 from "./conoce.vue?vue&type=style&index=0&id=40a55009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a55009",
  null
  
)

export default component.exports